export const regex = {
  email: /^[^\s@]+@[^\s@]+(\.)[^\s@]+$/,
  zipCode: /(^\d{5})(-\d{4})?$/
};
